export default "__VITE_ASSET__CvkTs$5Q__"